import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  Container,
  Grid,
  MenuItem,
  Typography,
  Link,
  Card,
  Button,
  Step,
  StepLabel,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Autocomplete,
} from '@mui/material';
import {
  LocalizationProvider,
  DatePicker,
} from '@mui/x-date-pickers';
import DateFnsUtils from '@date-io/date-fns';
import * as Yup from 'yup';
import NumberFormat from 'react-number-format';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { setNotIsFirstAccess } from 'redux/notIsFirstAccess';
import deLocale from 'date-fns/locale/pt-BR';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import moment from 'moment';
import './styles.css';
import WelcomeText from './formSteps/welcomeText/welcomeText';
import FarmGif from '../../images/gifs/gif-tela-criar-fazenda.gif';
import { CustomStepper } from 'components/CustomStepper/CustomStepper';
import { CycleInfo } from './formSteps/cycleInfo/cycleInfo';
import { setCycleCompleted } from 'redux/userSteps';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ImgLogo from '../../images/Ellipse.png';
import ImgCreve from '../../images/logo1.1.png';
import CloseIcon from '@mui/icons-material/Close';
import PlatformLogo from 'components/PlatformLogo';
import { POND_STATUS_CYCLE } from 'utils/consts';

function FirstCycle() {
  const notFirstAccess = useSelector(
    (state) => state.notIsFirstAccess.notIsFirstAccess,
  );
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle,
  );
  const location = useLocation();
  const [ponds, setPonds] = useState([]);
  const time = new Date();
  const outraData = new Date();
  outraData.setDate(time.getDate() + 120);
  const [selectedBeginDate, handleBeginDateChange] = useState(null);
  const [selectedEndDate, handleEndDateChange] = useState(null);
  const [selectedPond, setSelectedPond] = useState(null);
  const [description, setDescription] = useState('1');
  const classes = useStyles();
  const [cyclesStatus, setCyclesStatus] = useState([]);
  const [idPond, setIdPond] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  let { id } = useParams();
  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const matches = useMediaQuery('(max-width:900px)');
  const [dialogBemVindo, setDialogBemVindo] = useState(false);

  const handleClickOpen = () => {
    setDialogBemVindo(true);
  };

  const handleClose = () => {
    setDialogBemVindo(false);
    history.push('/home');
  };

  const [user, setUser] = useState(null);

  useEffect(() => {
    async function ini() {
      setUser(await api.get('users'));
    }
    ini();
  }, []);

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
        setSelectedPond(location.state.data.pond);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);

    formik.setFieldValue('pond', data.pond.id);
    // Problema
    if (data.id !== null) {
      handleBeginDateChange(
        data.begin !== null
          ? moment(data.begin?.substring(0, 10), 'YYYY-MM-DD').toDate()
          : null,
      );
      if (!data.end == null) {
        handleEndDateChange(new Date(data.end));
      }
      setSelectedPond(data.pond);
      setDescription(data.description);
    }
  }

  useEffect(() => {
    let apiSubscribed = true;
    async function load() {
      try {
        setOpenProgress(true);
        await api
          .get(`/ponds/availables/${selectedCycle?.id}`)
          .then((recponds) => {
            if (apiSubscribed) {
              if (
                selectedPond
                && !recponds.data.find((v) => v.id === selectedPond.id)
              ) {
                setSelectedPond(null);
              }
              setPonds(recponds.data);
            }
          });
      } catch (err) {
        console.error(err);
      } finally {
        setOpenProgress(false);
      }
    }
    if (selectedCycle?.id) {
      load();
    }

    return () => {
      apiSubscribed = false;
    };
  }, [selectedCycle]);

  useEffect(() => {
    // Prepara os dados para o componente DialogCicleViv
    async function statusCycle() {
      const idRoute = id;

      if (idRoute == undefined && selectedPond != undefined) {
        const idSelectedPond = selectedPond.id;
        const cycle_ = await api.get('/cycles');

        const statusCycle = [];
        const cyclesPond = [];

        if (cycle_.data.length !== 0) {
          cycle_.data.map((item) => {
            if (item.status === POND_STATUS_CYCLE.PREPARANDO || item.status === POND_STATUS_CYCLE.CULTIVANDO) statusCycle.push(item);
          });

          cycle_.data.map((item) => {
            if (item.pond === idSelectedPond) cyclesPond.push(item);
          });

          setCyclesStatus(statusCycle[0]);
          const cycleA = statusCycle.find(
            (cycle) => cycle.pond === idSelectedPond,
          );

          const cycleB = cyclesPond.find(
            (cycle) => cycle.description === description,
          );

          if (cycleB) {
            setDialog(true);
          }
          if (cycleA) {
            setIdPond(true);
          }
        }
      }
    }
    statusCycle();
    setDialog(false);
    setIdPond(false);
  }, [selectedPond, description]);

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    dispatch(setLoading(true));
    try {
      if (id) {
        await api.put(`/cycles/${id}`, { ...data });
      } else {
        await api.post('/cycles', { ...data });
      }
      success();
      if (user.data.firstAccess) {
        await api.put(`users/${user.data.id}`, {
          ...user.data,
          firstAccess: false,
        });
        dispatch(setNotIsFirstAccess(true));
        dispatch(setCycleCompleted(true));
      }
      handleClickOpen();
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      pond: '',
      cycleCode: selectedCycle,
      begin: '',
      end: '',
      population: 0,
      description: '',
      status: POND_STATUS_CYCLE.PREPARANDO,
      observation: '',
      density: '',
    },
    validationSchema: Yup.object({
      pond: Yup.number().required('Campo Obrigatório').nullable(),
      status: Yup.string().required('Campo Obrigatório'),
      density: Yup.number()
        .required('Campo Obrigatório')
        .min(1, 'Precisa ser acima de 1')
        .max(999999999, 'Valor máximo ultrapassado. Diminua a densidade')
        .typeError(
          'O valor deve ser um número. Caso seja um número decimal utilize " . " ao invés de " , "',
        ),
      population: Yup.number()
        .integer()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .typeError('O valor deve ser um número.')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua o tamanho da amostra',
        ),
    }),
    onSubmit: (values) => {
      values.begin = selectedBeginDate !== null
        ? moment(selectedBeginDate).format('YYYY-MM-DDT00:00:00[Z]')
        : null;
      values.end = selectedEndDate;
      values.pond = selectedPond.id;
      values.description = description;
      values.cycleCode = selectedCycle;
      request(values);
    },
  });

  useEffect(() => {
    if (formik.values.status === 'Concluído') handleEndDateChange(moment(Date.now()).format('YYYY-MM-DDT00:00:00[Z]'));
    else handleEndDateChange(null);
  }, [formik.values.status]);

  const [disableNextStep, setDisableNextStep] = useState(false);
  const [step, setStep] = useState(0);
  const steps = ['Passo 1'];

  return (
    <>
      <div>
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={dialogBemVindo}>
          <CloseIcon
            fontSize="large"
            onClick={handleClose}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              right: '1rem',
              top: '1rem',
              width: '25px',
            }}
          >
            X
          </CloseIcon>
          {/* <DialogTitle id="customized-dialog-title" onClose={handleClose}></DialogTitle> */}
          <DialogContent style={{ padding: '2.5rem 1rem 1.5rem' }}>
            <Typography>
              <div style={{
                position: 'relative', top: '0px', left: '0px', paddingBlock: '1rem .45rem',
              }}
              >
                <img src={ImgLogo} alt="" style={{ width: '34rem' }} />
              </div>
              <div style={{
                position: 'absolute', top: '5rem', textAlign: 'center', left: '3.5rem', marginTop: '1.5rem',
              }}
              >
                <div>
                  <PlatformLogo
                    styleGreenfyLogo={{
                      maxWidth: '236px',
                      height: '56px',
                    }}
                    styleBludoccLogo={{
                      maxWidth: '140px',
                    }}
                  />
                </div>
                <div style={{ fontSize: '25px', width: '29rem', marginBlock: '3rem' }}>Olá, seja bem-vindo à nossa plataforma, é um prazer tê-lo como cliente!</div>
              </div>
            </Typography>
          </DialogContent>
        </Dialog>
      </div>

      <Container style={{ padding: '3.5rem 8.125rem 3.5rem 8.9rem' }}>
        {openProgress ? <Progress /> : null}

        <Card className={classes.roundedPaper}>
          <Grid container className={classes.centralized}>
            <Grid
              xs={10}
              container
              className={classes.centralized}
              style={{ height: '70vh', padding: '4rem 1rem' }}
            >
              {step === 0 ? <WelcomeText setStep={setStep} /> : null}
              {step > 0 && (
                <Grid
                  container
                  item
                  component="form"
                  className={`${classes.root} ${classes.centralized}`}
                  onSubmit={formik.handleSubmit}
                  style={{ padding: '0 1rem' }}
                >
                  {step === 1 ? (
                    <CycleInfo
                      ponds={ponds}
                      setSelectedPond={setSelectedPond}
                      selectedPond={selectedPond}
                      id={id}
                      formik={formik}
                    />
                  ) : null}
                  {step > 0 ? (
                    <section
                      style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%',
                      }}
                    >
                      <div>
                        <CustomStepper activeStep={step - 1}>
                          {steps.map((label) => (
                            <Step key={label}>
                              <StepLabel />
                            </Step>
                          ))}
                        </CustomStepper>
                      </div>

                      <Grid>
                        <Button
                          className={classes.roundedButton}
                          disable={!formik.isValid}
                          type={formik.isValid ? 'submit' : 'button'}
                          variant="contained"
                          style={{
                            backgroundColor: !formik.isValid
                              && 'gray',
                          }}
                        >
                          <Typography style={{ textTransform: 'none', paddingInline: '1rem' }}>Concluir</Typography>
                        </Button>
                      </Grid>
                    </section>
                  ) : null}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Card>
        {/** Carregamento circular para o carregamento dos dados */}
      </Container>
    </>
  );
}

export default FirstCycle;
